import React from 'react';
import { motion } from 'framer-motion';
import { Gift, BookOpen, PenTool, HelpCircle } from 'lucide-react';
const BONUSES = [{
  title: 'Guía de Reflexión Personal',
  desc: '15 preguntas para ordenar lo que sentís',
  icon: <BookOpen className="w-8 h-8 text-blue-600" data-id="element-25" />,
  color: 'bg-blue-50 border-blue-200',
  image: 'https://cdn.magicpatterns.com/uploads/vnuHJrfPBhcmodvGbwzYNE/imagen_bonus_1.jpg'
}, {
  title: 'Diario de Claridad Emocional',
  desc: '30 días de escritura consciente',
  icon: <PenTool className="w-8 h-8 text-teal-600" data-id="element-26" />,
  color: 'bg-teal-50 border-teal-200',
  image: 'https://cdn.magicpatterns.com/uploads/rEQuuVJUe9MtX7YdVLyJKW/imagen_bonus_2.jpg'
}, {
  title: 'Cuando no sé qué hacer',
  desc: 'No para ordenar la vida. Solo para atravesar este momento.',
  icon: <HelpCircle className="w-8 h-8 text-amber-600" data-id="element-27" />,
  color: 'bg-amber-50 border-amber-200',
  image: 'https://cdn.magicpatterns.com/uploads/rVJHBste9pjK7k1VS2MKHp/imagen_bonus_3.jpg'
}];
export function BonusSection() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-gradient-to-b from-gray-50 to-white border-t border-gray-200" data-id="element-28">
      <div className="max-w-5xl mx-auto px-4" data-id="element-29">
        <div className="text-center mb-12" data-id="element-30">
          <span className="inline-block bg-red-100 text-red-700 font-bold px-4 py-1 rounded-full text-sm mb-4 animate-pulse" data-id="element-31">
            OFERTA LIMITADA
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900" data-id="element-32">
            🎁 BONOS EXCLUSIVOS —{' '}
            <span className="text-red-600" data-id="element-33">Solo por hoy, GRATIS</span>
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto" data-id="element-34">
            Estos recursos complementarios están diseñados para potenciar tu
            proceso de claridad.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-35">
          {BONUSES.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.15
        }} viewport={{
          once: true
        }} onClick={scrollToPurchase} className={`bonus-card cursor-pointer relative p-6 rounded-xl border-2 ${bonus.color} flex flex-col items-center text-center h-full`} data-id="element-36">
              <div className="absolute -top-3 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded shadow-sm" data-id="element-37">
                🎁 GRATIS HOY
              </div>

              <div className="mb-4 p-3 bg-white rounded-full shadow-sm" data-id="element-38">
                {bonus.icon}
              </div>

              <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-39">
                {bonus.title}
              </h3>
              <p className="text-gray-600 text-sm mb-4" data-id="element-40">{bonus.desc}</p>

              <div className="mt-auto pt-2 w-full" data-id="element-41">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto rounded-lg shadow-md object-cover" data-id="element-42" />
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-43">
          <p className="text-sm text-gray-500 italic" data-id="element-44">
            * Estos bonos desaparecerán pronto. Aprovechalos ahora.
          </p>
        </div>
      </div>
    </section>;
}